import Vue from 'vue'
import Router from 'vue-router'
import Clock from './views/ClockDesign/clockAppDesign.vue'
import ClockCreate from './views/allClock.vue'
import shortClockDesign from './views/ClockDesign/shortClockDesign.vue'
import randomBubbleClockDesign from './views/ClockDesign/randomBubbleClockDesign.vue'
import bubbleClockDesign from './views/ClockDesign/bubbleClockDesign.vue'
import barClockDesign from './views/ClockDesign/barClockDesign.vue'
import neonClockDesign from './views/ClockDesign/neonClockDesign.vue'
import nyanClock from './views/ClockDesign/nyanClockDesign.vue'

import textCount from './views/text-count.vue'
import timeCounter from './views/timeCounter.vue'
import ytComment from './views/ytComment.vue'
import toolMain from './views/toolMain.vue'
import rulesOfUse from './views/rulesOfUse.vue'
import discordroom from './views/discord-room.vue'
import timer from './views/simpleTimer.vue'
import news from './views/news.vue'
import counter from './views/counter.vue'
import counterDesign from './views/CounterDesign.vue'
import counterControl from './views/CounterControl.vue'
import simpleTimerDesign from './views/simpleTimerDesign.vue'
import simpleTimerControl from './views/simpleTimerControl.vue'
import roulette from './views/roulette.vue'
import ReactionTest from './views/ReactionTest.vue';
import ClickTest from './views/ClickTest.vue';
import BgCreate from './views/BgCreate.vue';
import BgDesign from './views/BgDesign.vue';

import premium from './views/premium/premiumMain.vue'
import premiumNyan from './views/premium/premium-nyan.vue'
import premiumFukidashi from './views/premium/premium-fukidashi.vue'
import premiumTransparent from './views/premium/premium-transparent.vue'
import premiumBarDesign from './views/premium/premiumBarDesign.vue'
import premiumTransparent1 from './views/premium/premium-transparent1.vue'
import nyan2 from './views/premium/premium-nyan2.vue'
import heart from './views/premium/premium-heart.vue'
import iconfukidashi from './views/premium/premium-iconfukidashi.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/tool/',
  base: '/tool/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: toolMain,
      meta: { title: 'はいしんツールキット|TOP', desc: 'ライブ配信活動に便利なツールキットをまとめました。YouTubeやTwitchの配信者向けの無料ツール集です。' }
    },
    {
      path: '/rule',
      name: 'rulesOfUse',
      component: rulesOfUse
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/ytcomment',
      name: 'ytcomment',
      component: ytComment,
      meta: { title: 'はいしんツールキット|YouTube・Twitchコメント欄', desc: 'YouTubeLIVE・Twitchのコメント欄を簡単にカスタマイズ。複数のデザインから選べる配信用コメント表示ツールです。' }
    },
    {
      path: '/timecounter',
      name: 'timecounter',
      component: timeCounter,
      meta: { title: 'はいしんツールキット|年越しカウンター', desc: '2023年までのカウントダウン。今年はあとどれくらい？' }
    },
    {
      path: '/textcount',
      name: 'textcount',
      component: textCount,
      meta: { title: 'はいしんツールキット|文字カウンター', desc: 'シンプルな文字カウンター。文字数を測りたいときに便利な無料ツールです。' }
    },
    {
      path: '/clockcreate',
      name: 'clock-create',
      component: ClockCreate,
      meta: { title: 'はいしんツールキット|配信用デジタル時計', desc: 'カスタマイズ可能な時計を複数用意。配信画面に表示できる自由なデザインの時計ツールです。' }
    },
    {
      path: '/timer',
      name: 'timer',
      component: timer,
      meta: { title: 'はいしんツールキット|タイマー', desc: 'シンプルなタイマー。同時視聴配信に便利なツールです。' }
    },
    {
      path: '/simpletimerdesign',
      name: 'simpletimerdesign',
      component: simpleTimerDesign,
      props: route => ({
        font: route.query.font
      })
    },
    {
      path: '/simpletimercontrol',
      name: 'simpletimercontrol',
      component: simpleTimerControl
    },
    {
      path: '/counter',
      name: 'counter',
      component: counter,
      meta: { title: 'はいしんツールキット|カウンター', desc: 'シンプルなカウンター。配信中のカウント管理や得点計算に便利な無料ツールです。' }
    },
    {
      path: '/clockdesign',
      name: 'clock-design',
      component: Clock
    },
    {
      path: '/shortclockdesign',
      name: 'shortclockdesign',
      component: shortClockDesign
    },
    {
      path: '/randombubbleclockdesign',
      name: 'randombubbleclockdesign',
      component: randomBubbleClockDesign
    },
    {
      path: '/bubbleclock',
      name: 'bubbleclock',
      component: bubbleClockDesign
    },
    {
      path: '/barclock',
      name: 'barclock',
      component: barClockDesign
    },
    {
      path: '/neonclock',
      name: 'neonclock',
      component: neonClockDesign
    },
    {
      path: '/nyanClock',
      name: 'nyanclock',
      component: nyanClock
    },
    {
      path: '/discordroom',
      name: 'discordroom',
      component: discordroom,
      meta: { title: 'はいしんツールキット|Discordオーバーレイ', desc: 'Discordのオーバーレイをカスタマイズする配信者向けツールです。' }
    },
    {
      path: '/counterdesign',
      name: 'counterdesign',
      component: counterDesign,
      props: route => ({
        count: parseInt(route.query.count),
        selectedFont: route.query.font,
        backgroundShape: route.query.shape,
        backgroundColor: route.query.color,
        textColor: route.query.text
      })
    },
    {
      path: '/countercontrol',
      name: 'countercontrol',
      component: counterControl
    },
    {
      path: '/premium',
      name: 'premium',
      component: premium
    },
    {
      path: '/premium-nyan',
      name: 'premium-nyan',
      component: premiumNyan
    },
    {
      path: '/premium-fukidashi',
      name: 'premium-fukidashi',
      component: premiumFukidashi
    },
    {
      path: '/premium-heart',
      name: 'premium-heart',
      component: heart
    },
    {
      path: '/premium-nyan2',
      name: 'premium-nyan2',
      component: nyan2
    },
    {
      path: '/premium-transparent',
      name: 'premium-transparent',
      component: premiumTransparent
    },
    {
      path: '/premium-transparent1',
      name: 'premium-transparent1',
      component: premiumTransparent1
    },
    {
      path: '/roulette',
      name: 'roulette',
      component: roulette
    },
    {
      path: '/reaction-test',
      name: 'reaction-test',
      component: ReactionTest,
      meta: { 
        title: '反射神経テスト | はいしんツールキット', 
        desc: '画面が緑色に変わったら素早くクリック！あなたの反射神経を測定します。ランクS+を目指して、オンラインで簡単に挑戦しよう。'
      }
    },
    {
      path: '/click-test',
      name: 'click-test',
      component: ClickTest,
      meta: { 
        title: 'クリック数テスト | はいしんツールキット', 
        desc: '10秒、30秒、60秒の時間でクリック速度（CPS）を測定します。あなたの連打能力をテストして、友達とスコアを競い合おう。' 
      }
    },
    {
      path: '/premium-bar-4a525eb2-3034-4891-908e-09cec275805f',
      name: 'premium-bar',
      component: premiumBarDesign
    },
    {
      path: '/premium-iconfukidashi',
      name: 'premium-iconfukidashi',
      component: iconfukidashi
    },
    {
      path: '/bgcreate',
      name: 'bgcreate',
      component: BgCreate,
      meta: { 
        title: '背景ジェネレータ | はいしんツールキット', 
        desc: 'カスタマイズ可能な背景ジェネレータ。グラデーション、水玉模様、記号、アニメーションを組み合わせてオリジナルの背景を作成できます。' 
      }
    },
    {
      path: '/bgdesign',
      name: 'bgdesign',
      component: BgDesign
    }
  ]
})